export const TUTOR_TP_JSON = [
  { id: -1, label: 'All' },
  { id: 1, label: 'up to 100' },
  { id: 2, label: '101 - 200' },
  { id: 3, label: '201 - 300' },
  { id: 4, label: '301 - 400' },
  { id: 5, label: '401 - 500' },
  { id: 6, label: '501 - 600' },
  { id: 7, label: '601 - 700' },
  { id: 8, label: '701 - 800' },
  { id: 9, label: '801 - 900' },
  { id: 10, label: '901 - 1000' },
];
